<template>
  <div class="modal-overlay z2500 sl-overlay" @click.self="$emit('close')">
    <div class="sl" role="dialog" aria-modal="true" aria-label="What's new">
      <button class="modal-close" @click="$emit('close')" aria-label="Close">✕</button>
      <div class="sl-title">🆕 What's new</div>
      <div class="sl-list">
        <div v-for="u in updates" :key="u.id" class="sl-item">
          <span class="sl-emoji">{{ u.emoji }}</span>
          <div class="sl-body">
            <div class="sl-head"><span class="sl-name">{{ u.title }}</span><span class="sl-date">{{ u.date }}</span></div>
            <div class="sl-desc">{{ u.body }}</div>
            <a v-if="u.link" :href="u.link" class="sl-link" :target="u.external ? '_blank' : null" :rel="u.external ? 'noopener' : null">Check it out →</a>
          </div>
        </div>
      </div>
      <div class="sl-foot">
        <button class="sl-got" @click="$emit('close')">Got it</button>
      </div>
    </div>
  </div>
</template>

<script>
import modalA11y from '../mixins/modalA11y.js';

export default {
  name: 'SpotlightModal',
  mixins: [modalA11y],
  emits: ['close'],
  props: {
    updates: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.sl-overlay { background: rgba(0, 0, 0, 0.72); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif; }
.sl { position: relative; width: 100%; max-width: 520px; max-height: 88vh; overflow-y: auto; background: linear-gradient(180deg, var(--panel-top), var(--panel-bottom)); border: 1px solid var(--brass-edge); border-radius: 6px; padding: 22px 26px 20px; color: var(--ink-hi); box-shadow: 0 14px 50px rgba(0, 0, 0, 0.6); text-align: left; }
.sl-title { font-size: 20px; margin-bottom: 14px; font-family: var(--display); font-weight: 700; color: var(--brass-hi); }

.sl-list { display: flex; flex-direction: column; gap: 10px; }
.sl-item { display: flex; gap: 10px; background: rgba(255, 255, 255, 0.04); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 8px; padding: 10px 12px; }
.sl-emoji { font-size: 22px; line-height: 1.2; flex: 0 0 auto; }
.sl-body { flex: 1; min-width: 0; }
.sl-head { display: flex; justify-content: space-between; align-items: baseline; gap: 8px; }
.sl-name { font-size: 14px; font-weight: bold; }
.sl-date { font-size: 11px; opacity: 0.5; }
.sl-desc { font-size: 12px; opacity: 0.8; line-height: 1.4; margin-top: 3px; }
.sl-link { display: inline-block; font-size: 11px; color: var(--brass); margin-top: 4px; }
.sl-link:hover { text-decoration: underline; }

.sl-foot { display: flex; justify-content: flex-end; margin-top: 16px; }
.sl-got { font-size: 13px; padding: 8px 20px; border-radius: 7px; cursor: pointer; background: rgba(18, 24, 38, 0.7); border: 1px solid var(--brass-edge); color: var(--ink); }
.sl-got:hover { background: rgba(217, 180, 94, 0.6); color: #fff; }
</style>
